import { CustomerMenuProduct } from "./customers";
import { Loyalty } from "./loyalty";

export enum DayEnum {
  MON = "mon",
  TUE = "tue",
  WED = "wed",
  THU = "thu",
  FRI = "fri",
  SAT = "sat",
  SUN = "sun",
}

export type HealthyPerk = {
  id?: string;
  product: CustomerMenuProduct;
  tiers: string[];
};

export type GetHealthyPerkResponseDto = {
  data: {
    mon: HealthyPerk[];
    tue: HealthyPerk[];
    wed: HealthyPerk[];
    thu: HealthyPerk[];
    fri: HealthyPerk[];
    sat: HealthyPerk[];
    sun: HealthyPerk[];
  };
};

export type UpdateHealthyPerkRequestData = {
  day: DayEnum;
  products: HealthyPerk[];
};

export type UpdateHealthyPerkRequestDto = {
  data: UpdateHealthyPerkRequestData;
};

export type ModifiedPerkItem = HealthyPerk & { tiersData?: Loyalty[] };

export type ModifiedHealthyPerkData = Record<DayEnum, ModifiedPerkItem[]>;
